

















































import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import CentralInsert from "@/components/miscellaneous/CentralInsert.vue";
import Configuration from "front-component/Configuration";
import Auth from "front-component/Auth";

const components = {
    CentralInsert,
};

@Component({ components })
export default class ForgottenPassword extends Vue {
    private newPassword: string = "";
    private confirmPassword: string = "";
    private loading: boolean = false;
    private changed: boolean = false;

    private created() {
        if (null === this.resetToken) {
            this.$router.push({ name: "home" });
        }
    }

    private get disableSubmit(): boolean {
        return this.loading || this.changed || !this.resetToken;
    }

    private get isValidPassword(): boolean {
        return 8 <= this.newPassword.length
            && /[a-z]/.test(this.newPassword)
            && /[A-Z]/.test(this.newPassword)
            && /\d/.test(this.newPassword);
    }

    private get isValid(): boolean {
        return !!this.resetToken
            && this.newPassword === this.confirmPassword
            && this.isValidPassword;
    }

    private get resetToken(): string|null {
        return _.get(this.$route, "query.token", null);
    }

    private triggerReset(): void {
        if (!this.resetToken || !this.isValid) {
            return;
        }

        this.loading = true;
        Auth.resetPassword(Configuration.get("authUri"), this.resetToken, this.newPassword).then(() => {
            this.$message({
                showClose: true,
                duration: 0,
                message: _.invoke(this.$options.filters, "trans", "resetEmailConfirm"),
                type: "success"
            });
            this.changed = true;
            this.loading = false;
            this.$router.push({ name: "home" });
        }).catch(() => {
            this.$message({
                showClose: true,
                duration: 0,
                message: _.invoke(this.$options.filters, "trans", "resetEmailError"),
                type: "error"
            });
            this.loading = false;
        });
    }
}
